import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  BranchInfoDTO,
  getBranchesForOpportunities,
} from '@user/store/opportunity'

export const useGetBranchDetailOnMount = (oppIds: number[]) => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  const [oppBranchInfo, setBranchInfo] = useState<BranchInfoDTO[]>([])

  useEffect(() => {
    if (!oppIds) {
      return
    }
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')
        setBranchInfo([])

        const result = await dispatch(getBranchesForOpportunities(oppIds))

        if (mounted) {
          if (getBranchesForOpportunities.fulfilled.match(result)) {
            setBranchInfo(unwrapResult(result))
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, oppIds])

  return { branchInfoStatus: status, oppBranchInfo }
}
